<template>
  <div class="smy__card-full-box">
    <Tabs value="record">
      <TabPane label="跟进记录" name="record">
        <Card>
          <FollowDetailRightOne
            ref="followDetailRightOne"
            :orderId="epId"
            :followDetail="followDetail"
          />
        </Card>
      </TabPane>
      <TabPane label="智能电话" name="phone">
        <FollowDetailRightTwo ref="followDetailRightTwo" />
      </TabPane>
      <TabPane label="活跃分析" name="count">
        <FollowDetailRightThree
          ref="followDetailRightThree"
          :opId="followDetail.id"
        />
      </TabPane>
      <TabPane
        label="组织架构"
        name="organization"
        v-if="user.isMain == 1 && user.sysrole == 1"
      >
        <FollowDetailRightFour ref="FollowDetailRightFour" :id="epId" />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import FollowDetailRightOne from './FollowDetailRightOne'
import FollowDetailRightTwo from './FollowDetailRightTwo'
import FollowDetailRightThree from './FollowDetailRightThree'
import FollowDetailRightFour from './FollowDetailRightFour'
import { mapState } from 'vuex'
export default {
  components: {
    FollowDetailRightOne,
    FollowDetailRightTwo,
    FollowDetailRightThree,
    FollowDetailRightFour,
  },
  props: {
    followDetail: {
      type: Array,
    },
  },
  data() {
    return {
      dataOne: 0,
      epId: '',
      pageIndex: 0,
      pageSize: 10,
    }
  },
  computed: {
    ...mapState('followCustom', ['id']),
    ...mapState('user', ['user']),
  },
  methods: {},
  created() {
    this.epId = this.id
    //  alert(this.epId)
  },
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailRight.vue